import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Sparkles, Copy } from "lucide-react";
import { streamSSE } from "@/components/AssistantBubble";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputCls = "w-full bg-white/60 border border-wood/25 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-terra";
const TYPES = [["newsletter", "Lettre d'intention (newsletter)"], ["evenement", "Description d'événement"], ["blog", "Article de blog"], ["libre", "Texte libre"]];

export const AdminRedaction = () => {
  const [type, setType] = useState("newsletter");
  const [titre, setTitre] = useState("");
  const [consigne, setConsigne] = useState("");
  const [texte, setTexte] = useState("");
  const [busy, setBusy] = useState(false);

  const generer = async (e) => {
    e.preventDefault();
    setBusy(true);
    setTexte("");
    try {
      await streamSSE(`${API}/assistant/rediger`, { type, titre, consigne }, (t) => setTexte((x) => x + t), { Authorization: `Bearer ${localStorage.getItem("elm_admin_token") || ""}` });
    } catch (err) {
      toast.error("Génération impossible pour le moment.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid lg:grid-cols-12 gap-8" data-testid="admin-redaction">
      <form onSubmit={generer} className="lg:col-span-5 bg-card border border-sand-dark rounded-2xl p-8 space-y-4">
        <p className="eyebrow mb-2 flex items-center gap-2"><Sparkles className="w-4 h-4 text-terra" /> Aide à la rédaction (Claude)</p>
        <div>
          <label className="eyebrow block mb-2" htmlFor="redac-type">Type de texte</label>
          <select id="redac-type" data-testid="redaction-type" value={type} onChange={(e) => setType(e.target.value)} className={inputCls}>
            {TYPES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </div>
        <div>
          <label className="eyebrow block mb-2" htmlFor="redac-titre">Titre / sujet (optionnel)</label>
          <input id="redac-titre" data-testid="redaction-titre" value={titre} onChange={(e) => setTitre(e.target.value)} className={inputCls} placeholder="Ex. Lettre de novembre — Samhain et nouveaux stages" />
        </div>
        <div>
          <label className="eyebrow block mb-2" htmlFor="redac-consigne">Consigne</label>
          <textarea id="redac-consigne" data-testid="redaction-consigne" required rows={7} value={consigne} onChange={(e) => setConsigne(e.target.value)} className={`${inputCls} resize-none`}
            placeholder="Ce qu'il faut dire : nouvelles de l'atelier, dates à annoncer, ton souhaité, longueur…" />
        </div>
        <button type="submit" disabled={busy} data-testid="redaction-generer" className="px-6 py-3 rounded-full bg-terra text-earth text-sm hover:bg-earth transition-colors disabled:opacity-50 inline-flex items-center gap-2">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} {busy ? "Rédaction en cours…" : "Rédiger"}
        </button>
      </form>
      <div className="lg:col-span-7 bg-card border border-sand-dark rounded-2xl p-8">
        <div className="flex items-center justify-between mb-4">
          <p className="eyebrow">Proposition — modifiable</p>
          <button type="button" disabled={!texte} onClick={() => { navigator.clipboard.writeText(texte); toast.success("Texte copié"); }} data-testid="redaction-copier"
            className="px-4 py-2 rounded-full border border-wood/25 text-xs hover:border-terra hover:text-terra transition-colors disabled:opacity-40 inline-flex items-center gap-1.5"><Copy className="w-3.5 h-3.5" /> Copier</button>
        </div>
        <textarea data-testid="redaction-resultat" value={texte} onChange={(e) => setTexte(e.target.value)} rows={22} className={`${inputCls} resize-y font-serif text-base leading-relaxed`} placeholder="Le texte apparaîtra ici, mot après mot." />
      </div>
    </div>
  );
};
